export const downloadFile = async (url: string, fileName: string) => {
  const isRemoteUrl = /^https?:\/\//i.test(url);
  const link = document.createElement('a');
  let objectUrl: string | null = null;

  try {
    if (isRemoteUrl) {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Failed to download file: ${response.status}`);
      }
      objectUrl = URL.createObjectURL(await response.blob());
    }

    link.href = objectUrl ?? url;
    link.download = fileName;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    link.remove();
  } finally {
    if (objectUrl) {
      URL.revokeObjectURL(objectUrl);
    }
  }
};
